import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';
import { PatientTemplateCustomOrderingDoctorAddTemplate } from "themes/application/niko-patient/components";
import { PatientTemplateCustomOrderingDoctorAddViewStore } from "../stores";

@setCurrentView((rootStore, componentProps) => new PatientTemplateCustomOrderingDoctorAddViewStore(rootStore, componentProps), 'patientTemplateCustomOrderingDoctorAddViewStore')
@observer
class PatientTemplateCustomOrderingDoctorAdd extends React.Component {
	render() {
		return <PatientTemplateCustomOrderingDoctorAddTemplate {...this.props} />;
	}
}

export default PatientTemplateCustomOrderingDoctorAdd;